export const ACCE_KELLY_PARAMS = {
  referenceCapital: 10000,
  baseContracts: 4,

  kellyFractionUsed: 0.182063,
  fixedRiskPerContract: 330,

  minContracts: 4,
  maxContracts: 20,
};

export function calculateAcceKellyContracts(currentCapitalInput) {
  const currentCapital = Number(currentCapitalInput);

  if (!Number.isFinite(currentCapital) || currentCapital <= 0) {
    return {
      currentCapital: 0,
      modelContracts: ACCE_KELLY_PARAMS.minContracts,
      recommendedContracts: ACCE_KELLY_PARAMS.minContracts,
      rawContracts: 0,
      capped: false,
      valid: false,
    };
  }

  // ACCE ALWAYS begins at 4 contracts on the first $10,000.
  // Kelly scaling applies only to equity above the $10,000 base.
  const excessCapital = Math.max(
    0,
    currentCapital - ACCE_KELLY_PARAMS.referenceCapital
  );

  const additionalRawContracts =
    (excessCapital * ACCE_KELLY_PARAMS.kellyFractionUsed) /
    ACCE_KELLY_PARAMS.fixedRiskPerContract;

  const additionalContracts = Math.floor(additionalRawContracts);

  let modelContracts =
    ACCE_KELLY_PARAMS.baseContracts + additionalContracts;

  modelContracts = Math.max(
    ACCE_KELLY_PARAMS.minContracts,
    modelContracts
  );

  const capped =
    modelContracts > ACCE_KELLY_PARAMS.maxContracts;

  modelContracts = Math.min(
    modelContracts,
    ACCE_KELLY_PARAMS.maxContracts
  );

  return {
    currentCapital,
    modelContracts,
    recommendedContracts: modelContracts,
    rawContracts:
      ACCE_KELLY_PARAMS.baseContracts + additionalRawContracts,
    capped,
    valid: true,
  };
}